// removed by extract-text-webpack-plugin
module.exports = {"disclaimerId":"_1T9iI1oxmn"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Dashboard/ImportantInformation/Disclaimers/Disclaimers-ThirdParty.module.less
// module id = 980
// module chunks = 3